export default {
  en: {
    'negotiations': 'negotiations',
    'negotiation': 'negotiation',
    'negotiators': 'negotiators',
    'diplomacy': 'diplomacy',
    'initiate_talks': 'initiate talks',
    'status': 'status',
    'opened': 'opened',
    'closed': 'closed',
    'failed': 'failed',
    'no_active_negotiations': 'No active negotiations.',
    'no_next_game': 'no next game',
    'negotiation_failed': 'negotiation failed',
    'negotiation_target_does_not_want_to_talk_to_you': 'Negotiation target does not want to talk to you!',
    'negotiation_closed': 'negotiation closed',
    'daily': 'daily',
    'monthly': 'monthly',
    'yearly': 'yearly',
    'once': 'once',
    'negotiation_attributes': 'negotiation attributes',
    'negotiation_progress': 'negotiation progress',
    'close_negotiation': 'close negotiation',
    '': '',
  }
};